import { ReactNode, useState } from "react"
import { cn } from "@/lib/utils"
import { CmrReport } from "./CmrReport"
import { useCmrReportMode } from "./useCmrReportMode"
import { TabType } from "@/reducers/tabsSlice"
import { useTranslation } from "react-i18next"

type CmrSubTab = "chat" | "report"

export function CmrRoomTabs({
  chatContent,
  onNavigateToChat,
}: {
  chatContent: ReactNode
  onNavigateToChat: (jid: string, tab?: TabType) => void
}) {
  const { t } = useTranslation()
  const { enabled: isReportEnabled } = useCmrReportMode()
  const [activeSubTab, setActiveSubTab] = useState<CmrSubTab>("chat")

  if (!isReportEnabled) {
    return <div className="h-full">{chatContent}</div>
  }

  return (
    <div className="flex h-full flex-col">
      <div className="flex border-b bg-sidebar">
        <button
          className={cn(
            "px-4 py-2 text-sm font-medium transition-colors",
            activeSubTab === "chat"
              ? "border-b-2 border-primary text-primary"
              : "text-muted-foreground hover:text-foreground",
          )}
          onClick={() => setActiveSubTab("chat")}
        >
          {t("reports.cmrRoomTabs.documents")}
        </button>
        <button
          className={cn(
            "px-4 py-2 text-sm font-medium transition-colors",
            activeSubTab === "report"
              ? "border-b-2 border-primary text-primary"
              : "text-muted-foreground hover:text-foreground",
          )}
          onClick={() => setActiveSubTab("report")}
        >
          {t("reports.cmrRoomTabs.report")}
        </button>
      </div>
      <div className="flex-1 overflow-hidden">
        {activeSubTab === "chat" ? (
          <div className="h-full">{chatContent}</div>
        ) : (
          <CmrReport onNavigateToChat={onNavigateToChat} />
        )}
      </div>
    </div>
  )
}
